import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05d1b04e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=05d1b04e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1b04e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d1b04e')) {
      api.createRecord('05d1b04e', component.options)
    } else {
      api.reload('05d1b04e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05d1b04e&scoped=true", function () {
      api.rerender('05d1b04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/LayoutHead/HeadNav/index.vue"
export default component.exports